export const en = {
    projects: 'My Projects',
    portfolio: 'Portfolio',
    gitRepository: 'Git repository',
    demo: 'Demo',
    descriptionIReserve: 'Website for a thesis, allowing users to book hotels in a hotel chain, with a personal account, booking tracking and an administrator account for managing the website content, editing the site in the menu, using technologies such as React, JavaScript, Redux, Docker, MongoDB, Express, JWT, React Router 6, Node.',
    descriptionVertical: 'Stylish vertical Slider, technologies used in the project: HTML, CSS, JavaScript',
    descriptionParallax: 'Learning project. Parallax scrolling web, technologies used in the project: HTML, CSS, JavaScript',
    descriptionSteelStore: 'Project for a store, using technologies such as React, JavaScript, Redux, Docker, Express, JWT, React Router 6, Node.',
    descriptionPaintSelector: 'Commercial project. Paint selector for external and interior work, technologies used in the project: HTML, SCSS, TypeScript, React',
    phone: 'Phone',
    name: 'Alexander Shulgin',
    profession: 'Frontend Developer',
    contacts: 'Contacts',
    stack: 'My stack technologies:',
    footerNote: 'I will be glad to cooperate',
    changeTheme: 'Change theme',
    changeLanguage: 'Change language EN',

  };